import { useIntl } from "react-intl";

import { useLocalizedHref } from "@/libraries/web-framework";

const Databases = () => {
    const intl = useIntl();

    const messages = {
        header: intl.formatMessage({
            id: "ConfluencePricingPage.features.Databases.header",
            defaultMessage: "Databases"
        }),
        content: intl.formatMessage(
            {
                id: "ConfluencePricingPage.features.Databases.content",
                defaultMessage:
                    "Confluence databases allow users to aggregate, structure, and connect information, driving consistency and visibility across teams. <learnMore>Learn more.</learnMore>"
            },
            {
                learnMore: (chunks: React.ReactNode) => (
                    <a
                        // eslint-disable-next-line react-hooks/rules-of-hooks
                        href={useLocalizedHref(
                            "/software/confluence/databases"
                        )}
                        data-event="clicked"
                        data-event-component="linkButton"
                        data-product-key="confluence"
                        data-label-english="Learn more"
                        data-track-event="ConfluencePricingPage.Databases.learnMore"
                        data-event-container="ConfluencePricingPage"
                    >
                        {chunks}
                    </a>
                )
            }
        ),
        altText: intl.formatMessage({
            id: "ConfluencePricingPage.features.Databases.altText",
            defaultMessage: "Example of databases"
        })
    };

    return (
        <>
            <h2>{messages.header}</h2>
            <p>{messages.content}</p>
            <img
                src="https://wac-cdn.atlassian.com/misc-assets/webp-images/confluence-pricing-database-modal-2712266192.webp"
                alt={messages.altText}
                height={350}
                loading="lazy"
            />
        </>
    );
};

export default Databases;
